import { SplixerResourceInterface } from './splixer-resource.interface';
import { AnyHash, NameableInterface } from '@hidat/huijs-common';
import { ResourceConfig } from '@hidat/huijs-resource';

export const UserMixConfig = new ResourceConfig(
  'UserMix',
  'user_mixes',
  true,
  true,
);

export interface UserMixInterface
  extends SplixerResourceInterface<number>, NameableInterface {
  instanceId: number | undefined;
  listenerId: number | undefined;
  stationId: number | undefined;
  contentPathId: number | undefined;
  mixConfig: AnyHash;
}
